<template>
  <div class="pc-account-switcher-sm-container">
    <pc-tooltip :disabled="!hasMultipleAccounts" value="Switch account">
      <v-select
        :readonly="!hasMultipleAccounts"
        class="pc-account-switcher"
        :background-color="$colors.penChecksBlueGray"
        :color="$colors.white"
        :id="id"
        item-text="displayName"
        item-value="id"
        :items="accounts"
        :menu-props="{ contentClass: 'pc-account-switcher-menu' }"
        :disabled="disabled"
        dense
        solo
        flat
        dark
        hide-details
        v-model="selectedAccountId"
      >
        <template v-slot:append>
          <pc-icon
            class="pc-account-switcher-chevron"
            :size="12"
            name="pc-scroll-down"
            :class="{ 'd-none': !hasMultipleAccounts }"
          ></pc-icon>
        </template>

        <template v-slot:prepend-inner>
          <div class="pc-account-switcher-avatar">
            <v-avatar color="white" size="32">
              <span class="pc-account-switcher-letter">{{
                selectedAccountFirstLetter
              }}</span>
            </v-avatar>
          </div>
        </template>

        <template v-slot:item="{ item }">
          <div class="pc-account-switcher-item-container">
            <pc-tooltip avoid-overflow :value="item.displayName">
              <span class="pc-account-switcher-item-text">
                {{ item.displayName }}
              </span>
            </pc-tooltip>
            <pc-icon
              class="pc-account-switcher-checkmark"
              name="pc-checkmark"
              size="12"
            ></pc-icon>
          </div>
        </template>

        <template v-if="small" v-slot:selection></template>
      </v-select>
    </pc-tooltip>
  </div>
</template>

<script>
import PcTooltip from "../PcTooltip.vue";
import AccountUser from "@/shared/lib/client-sdk/models/account-user";
import User from "@/shared/lib/client-sdk/models/user";

export default {
  components: { PcTooltip },
  props: {
    accounts: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: undefined,
    },
    id: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    redirectPathPrefix: {
      type: String,
      default: "",
    },
  },
  methods: {
    redirect: function (selectedAccountId) {
      //set last Access Master Account and redirect
      if (this.$store.state.authenticatedUser) {
        let alreadyInAccount = this.$route.params.accountUuid === selectedAccountId;

        var accountUser = new AccountUser({
          accountId: selectedAccountId,
          userId: this.$store.state.authenticatedUser.id,
        });

        accountUser.setUserAccessAccount(() => {
          if (!alreadyInAccount) {
            window.location = this.redirectPathPrefix + "/" + selectedAccountId;
          }
        });
      }
    },
  },
  computed: {
    selectedAccountId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.redirect(value);
      },
    },
    selectedAccountFirstLetter: function () {
      let account = this.accounts.find((x) => x.id === this.selectedAccountId);
      let accountName = account?.displayName;
      return accountName ? accountName.charAt(0).toUpperCase() : "";
    },
    hasMultipleAccounts: function () {
      return this.accounts.length > 1;
    },
  },

  mounted: function () {
    if (this.hasMultipleAccounts) {
      User.fetchAuthenticatedUser(
        function (user) {
          if (user && user.isClient()) {
            this.$store.commit("setAuthenticatedUser", user);
          }
        }.bind(this)
      );
    }
  },
};
</script>

<style lang="scss">
.pc-account-switcher.v-text-field--outlined,
.v-text-field--solo {
  border-radius: 0px !important;
}

.pc-account-switcher-letter {
  color: $penChecksNavyBlue;
}

.pc-account-switcher-menu.v-menu__content {
  border-radius: 0px !important;
  width: 256px !important;
  margin-top: 48px;
  top: 0px !important;
  left: 0px !important;
}

.pc-account-switcher-menu .v-list {
  border-radius: 0px !important;
}
.pc-account-switcher-avatar {
  padding: 8px 7px 8px 0px !important;
}

.pc-account-switcher-container {
  width: 256px !important;
}

.pc-account-switcher .v-select__selection {
  font-size: clamp(14px, 16px, 16px) !important;
  text-overflow: ellipsis !important;
}

.pc-account-switcher-checkmark {
  display: none !important;
  color: $penChecksTeal !important;
  padding-top: 6px;
}

.v-list-item--active .pc-account-switcher-checkmark {
  display: block !important;
}

.pc-account-switcher-item-container {
  display: flex;
  justify-content: space-between;
  width: 100% !important;
}

.v-application .pc-account-switcher-menu .primary--text {
  color: transparent !important;
  opacity: 1 !important;
  background: #ebf3f5 !important;
}

.pc-account-switcher .v-select__selection {
  max-width: 156px !important;
}

.pc-account-switcher-item-text {
  color: $penChecksDarkGray !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  color: $penChecksDarkGray !important;
  max-width: 200px;
  display: block;
}

.pc-account-switcher-chevron {
  margin-right: 4px !important;
}
</style>
